import React from 'react';
import {BackdropContainer} from './style';
const Backdrop = (props) => {
    return (
        <BackdropContainer onClick = {props.backdropClick}>

        </BackdropContainer>
    )
}
export default Backdrop;